<template>
  <MegaMenu
      :items="menuItems"
      v-model="activeSection"
      :gap="gap"
      :mode="mode"
      :active-background="activeBackground"
      :active-color="activeColor"
      :animation-duration="animationDuration"
      :uniform-style="uniformStyle"
      :active-filled-highlight="['brightness', 'bold']"
      :active-outline-highlight="['bold']"
      :pause-animation-on-active="true"
      :padding-x="paddingX"
      :padding-y="paddingY"
      @item-click="onItemClick"
      :enable-performance-monitoring="false"
      external-update-mode="debounced"
  />
</template>

<script setup lang="ts">
import {computed} from "vue";
import {storeToRefs} from "pinia";
import {useRoute, useRouter} from "vue-router";
import MegaMenu, {AdvMenuItem, MenuOverflowMode} from "@/components/Ui/MegaMenu/MegaMenu.vue";
import {useCatalogStore} from "@/modules/shop/store/catalog";
import {usePageFrontStore} from "@/stores/page-front";
import {ICONS} from "@/assets/icons";
import {useQuasar} from "quasar";

interface Props {
  gap?: number;
  /** Режим отображения: dropdown или slider */
  mode?: MenuOverflowMode;
  activeBackground?: string;
  activeColor?: string;
  animationDuration?: number;
  /** Отключить кастомное оформление пунктов */
  uniformStyle?: boolean;
  /** Включить динамическое изменение цвета текста под индикатором (экспериментально) */
  enableTextColorTransition?: boolean;
  paddingX?: string;
  paddingY?: string;
  isFirstScreen?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  gap: 8,
  mode: "dropdown",
  activeBackground: "#ce8714",
  activeColor: "#ffffff",
  animationDuration: 300,
  uniformStyle: false,
  enableTextColorTransition: true,
});

const route = useRoute();
const router = useRouter();

const catalogStore = useCatalogStore();
const {sectionsTree} = storeToRefs(catalogStore);

const pageFrontStore = usePageFrontStore();
const {setActiveSection} = pageFrontStore;
const {activeSection} = storeToRefs(pageFrontStore);

const $q = useQuasar()

const menuItems = computed<AdvMenuItem[]>(() => {
  const res: AdvMenuItem[] = []

  if ($q.screen.lt.md && false) {
    /*
    res.push({
      id: "sections",
      icon: ICONS.homeOutline,
      activeIcon: null,
      bgColor: null,
      // label: 'Меню',
      // hidden: props.isFirstScreen,
      indicatorColor: '#CCCCCC',
    })
     */
  }

  // Добавляем пункт "Подборки"
  /*
  res.push({
    id: "collections",
    label: "Подборки",
    icon: 'collections_bookmark',
    activeIcon: null,
    indicatorColor: '#ce8714',
    textColor: '#ce8714',
  })
*/

  res.push(...sectionsTree.value.map((section) => {
    const props = section.PROPERTIES || {};

    const item: AdvMenuItem = {
      id: section.CODE!,
      label: section.NAME!,
      icon: props.MENU_ICON?.SRC ? 'img:' + props.MENU_ICON.SRC : null,
      activeIcon: props?.MENU_FOCUSED_ICON?.SRC ? 'img:' + props?.MENU_FOCUSED_ICON.SRC : null,
      url: `/catalog/${section.CODE}`,
    };

    if (props.MENU_COLOR) {
      item.textColor = props.MENU_COLOR;
      item.indicatorColor = props.MENU_COLOR;
    }

    if (props.MENU_ITEM_STYLE === 'filled' || props.MENU_ITEM_STYLE === 'outline') {
      item.mode = props.MENU_ITEM_STYLE
      item.bgColor = props.MENU_COLOR;
    }

    if (props.MENU_ITEM_STYLE === 'filled') {
      // item.textBlink = true
      //item.animation = 'glow'
    }

    return item
  }))

  return res
});

const onItemClick = (item: AdvMenuItem) => {
  if (route.path === "/") {
    setActiveSection(item.id);
  } else {
    router.push({path: "/", hash: "#" + item.id});
  }
};
</script>
